async function u(t, e = "h0n3yp0t!@") {
  const n = new TextEncoder(), r = n.encode(t), c = await crypto.subtle.importKey("raw", r, "PBKDF2", !1, [
    "deriveBits"
  ]), a = { name: "PBKDF2", hash: "SHA-256", salt: n.encode(e), iterations: 1337 }, o = await crypto.subtle.deriveBits(a, c, 48 * 8), s = 32, i = o.slice(0, s), d = o.slice(s);
  return {
    key: await crypto.subtle.importKey(
      "raw",
      i,
      { name: "AES-GCM" },
      !1,
      ["encrypt", "decrypt"]
    ),
    iv: d
  };
}
async function f(t, e) {
  const r = new TextEncoder().encode(t);
  return await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: e.iv },
    e.key,
    r
  );
}
async function l(t, e) {
  const n = new TextDecoder("utf-8"), r = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: e.iv },
    e.key,
    t
  );
  return n.decode(r);
}
export {
  l as decrypt,
  f as encrypt,
  u as getKeyFromPassword
};
//# sourceMappingURL=dha-encryption.es.js.map
